<script>
import { mapState, mapGetters } from 'vuex'


export default {
  name: 'Loader',
  data() {
    return {
      moreDetails: false
    }
  },
  watch: {

  },
  computed: {
    ...mapState({
      status: state => state.loader.status,
      detail: state => state.loader.detail,
      subdetail: state => state.loader.subdetail,
    }),
    ...mapGetters({
      show: 'loader/show'
    }),
    barVal() {
      if(this.status != 'LOADING') {
        return 100
      }
      return 0
    },
    lineColor() {
      if(this.status == 'ERROR' || this.status == '') {
        return '#A90100'
      }
      if(this.status == 'COMPLETE') {
        return '#5aa723'
      }
      if(this.status == 'LOADING') {
        return '#5aa723'
      }
      return ''
    },
    detailColor() {
      if(this.status == 'ERROR' || this.status == '') {
        return '#A90100'
      }
      if(this.status == 'COMPLETE') {
        return '#00AA00'
      }
      if(this.status == 'LOADING') {
        return '#2e2e2e'
      }
      return ''
    },
  },
  methods: {
    close() {
      this.$store.dispatch('loader/CHANGE', {
        status: '',
        detail: '',
        subdetail: '',
      })
    }
  }
}
</script>

<template>
  <v-dialog
      v-if="show"
      v-model="show"
      persistent
      no-click-animation
      width="800"
      max-width="75%"
    >

        <v-card tile class="pa-8">
          <v-card-title>
            <div :style="{ color: detailColor, borderBottom: `solid 2px ${ lineColor }` }" class="pb-0 heading font-weight-bold" v-html="detail"></div>
          </v-card-title>
          <v-card-text>
            <div :style="{ color: detailColor }" v-if="status != 'ERROR'" class="subdetail" v-html="subdetail"></div>
            <div v-if="status === 'ERROR'" class="font-weight-bold"> See more info <v-icon @click="moreDetails = !moreDetails" color="error">mdi-information-outline</v-icon></div>
            <div v-if="moreDetails" :style="{ color: detailColor }" class="subdetail pt-2" v-html="subdetail"></div>
            <v-progress-linear
              :color="lineColor"

              :indeterminate="status == 'LOADING'"
              :value="barVal"

              height="10"
              class="my-2"
            ></v-progress-linear>

          </v-card-text>
          <v-card-actions class="pl-6">
            <v-btn @click="close" small v-if="status === 'ERROR'">close</v-btn>
          </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<style scoped lang="scss">
  .heading {
    font-size: 16px;
    line-height: 30px;
    color: $secondary-color;

    text-transform: uppercase;
  }
  .subdetail {
    color: $secondary-color;
    position: relative;
    font-size: 14px;
    top: -5px;
  }
</style>
